import React from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const INCLUDED = [
  "Professional training kit included",
  "Comprehensive training manual",
  "Hands-on practical training",
  "Models provided, or bring your own",
  "Ongoing mentoring & support after training",
  "AIT Accredited Certification on completion of three case studies",
];

const COURSES = [
  { name: "Beginner Classic Lash Extensions", duration: "2-Day Course", price: 550,
    desc: "The perfect course for complete beginners. Learn everything you need to confidently offer Classic Lash Extensions.",
    points: ["Lash theory", "Health & safety", "Client consultation", "Lash styling & mapping", "Application techniques", "Infills & removals", "Aftercare", "Practical training"] },
  { name: "Volume Lash Extensions", duration: "1-Day Course", price: 450,
    desc: "Take your lash skills to the next level by mastering handmade volume fans and creating beautiful, fuller lash sets. Perfect for qualified Classic Lash technicians looking to expand their services.", points: [] },
  { name: "LED Lash Extensions", duration: "1-Day Course", price: 500,
    desc: "Learn the latest innovation in lash extensions using LED curing technology. Covers everything you need to safely and confidently offer this premium treatment.", points: [] },
  { name: "Classic & Volume Lash Bundle", duration: "Two Weekends", price: 800,
    desc: "The ultimate lash training package. Complete both the Beginner Classic and Volume courses and save while gaining the skills to offer both treatments to your clients.", points: [] },
  { name: "Henna Brows", duration: "1-Day Course", price: 450,
    desc: "Master the art of beautifully defined brows through brow mapping, shaping, henna application, colour matching, and professional finishing techniques.", points: [] },
  { name: "Brow Lamination", duration: "1-Day Course", price: 450,
    desc: "Learn one of the beauty industry's most requested brow treatments.",
    points: ["Brow consultation", "Brow mapping", "Lamination process", "Tinting", "Shaping", "Finishing", "Aftercare"] },
];

export default function TrainingPage() {
  const [busy, setBusy] = React.useState(null);

  const book = async (course) => {
    setBusy(course.name);
    try {
      const { data } = await axios.post(`${API}/training/deposit`, {
        course_name: course.name, course_price: course.price, origin_url: window.location.origin,
      });
      if (data.checkout_url) window.location.href = data.checkout_url;
    } catch (e) {
      setBusy(null);
    }
  };

  return (
    <div className="pb-16" data-testid="training-page">
      <header className="mb-8 max-w-2xl">
        <p className="text-[11px] uppercase tracking-[0.25em] text-neutral-500">Training</p>
        <h1 className="mt-1 text-2xl font-medium tracking-tight text-neutral-900 md:text-3xl">
          Elevate your beauty career with professional lash & brow training
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-neutral-600">
          Ready to turn your passion into a career or expand your treatment menu? My accredited
          training courses give you the confidence, knowledge and practical skills to become a
          successful Lash & Brow Artist. With small class sizes, hands-on learning, ongoing support
          and professional kits included, you'll leave feeling confident and ready to start your journey.
        </p>
      </header>

      <div className="grid gap-5 md:grid-cols-2">
        {COURSES.map((c) => (
          <article key={c.name} data-testid={`course-${c.name.replace(/\s+/g, "-").toLowerCase()}`}
            className="flex flex-col rounded-3xl border border-neutral-200 bg-white p-6">
            <div className="flex items-start justify-between gap-3">
              <h2 className="text-lg font-medium text-neutral-900">{c.name}</h2>
              <span
                data-testid={`spots-${c.name.replace(/\s+/g, "-").toLowerCase()}`}
                className="shrink-0 rounded-full bg-rose-50 px-3 py-1 text-[10px] font-medium uppercase tracking-[0.2em] text-rose-600">
                Limited spots
              </span>
            </div>
            <p className="mt-1 text-xs uppercase tracking-[0.2em] text-neutral-500">
              {c.duration} · €{c.price}
            </p>
            <p className="mt-3 text-sm leading-relaxed text-neutral-600">{c.desc}</p>
            {c.points.length > 0 && (
              <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1 text-xs text-neutral-600">
                {c.points.map((p) => <li key={p}>• {p}</li>)}
              </ul>
            )}
            <div className="mt-auto pt-5">
              <button type="button" onClick={() => book(c)} disabled={busy === c.name}
                data-testid={`book-${c.name.replace(/\s+/g, "-").toLowerCase()}`}
                className="inline-flex h-11 w-full items-center justify-center rounded-full bg-black px-6 text-[11px] font-medium uppercase tracking-[0.25em] text-white transition-colors hover:bg-neutral-800 disabled:bg-neutral-300">
                {busy === c.name ? "Redirecting…" : "Book Now — €150 deposit"}
              </button>
              <p className="mt-2 text-center text-[11px] text-neutral-400">
                €150 deposit secures your spot · balance €{c.price - 150} due at training
              </p>
            </div>
          </article>
        ))}
      </div>

      <section className="mt-10 rounded-3xl border border-neutral-200 bg-white p-6">
        <h2 className="text-sm font-medium uppercase tracking-[0.25em] text-neutral-700">Every course includes</h2>
        <ul className="mt-4 grid gap-2 text-sm text-neutral-700 sm:grid-cols-2">
          {INCLUDED.map((i) => <li key={i}>✨ {i}</li>)}
        </ul>
      </section>
    </div>
  );
}
